import {isValidItemDecimal} from '@/utils/itemInputValidation';

export function isValidExpenseAmount(value) {
    return isValidItemDecimal(value, false, 5);
}

export function trimmedExpenseCategoryName(value) {
    return value.trim();
}
